/**
 * FIBO 2 render responses carry numeric VGL fields as model tokens — `"<color_222>"`,
 * `"<coord_33.2>"` — exactly as the model yields them, while captioner/refine output
 * and our own edits carry plain numbers. Every read of a VGL color channel or
 * coordinate must go through `vglNumber` so both forms work; write-back is always
 * plain numbers (the fal endpoints accept either).
 */

/** A numeric VGL field as it appears on the wire: a number, or a token string. */
export type VglScalar = number | string;

const TOKEN_RE = /^<[a-z][a-z0-9_]*_(-?\d+(?:\.\d+)?)>$/i;

/** Numeric value of a VGL scalar (number, token, or numeric string) — else undefined. */
export const vglNumber = (value: unknown): number | undefined => {
	if (typeof value === "number") return Number.isFinite(value) ? value : undefined;
	if (typeof value !== "string") return undefined;
	const trimmed = value.trim();
	const token = TOKEN_RE.exec(trimmed);
	if (token) return Number(token[1]);
	if (trimmed !== "" && Number.isFinite(Number(trimmed))) return Number(trimmed);
	return undefined;
};

export const isVglNumber = (value: unknown): boolean => vglNumber(value) !== undefined;
